import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { useUk } from '../../../../hooks'
import { Divider } from '../../../Divider'
import { IconWithTooltip } from '../../../Icon'
import {
  ProfileUserInfoItem,
  Widget,
  WidgetContentItemsList,
} from '../../../Widget'
import { RequestProfileWidgetKey } from '../RequestProfileWidget.constants'

import {
  getRequestProfileWidgetDwellersAndLandlordsData,
  getRequestProfileWidgetDwellersAndLandlordsSectionTitle,
  getRequestProfileWidgetDwellersAndLandlordsSectionVisibilityTooltipKey,
} from './RequestProfileWidgetDwellersAndLandlords.utils'
import { RequestProfileWidgetDwellersAndLandlordsHeaderActions } from './RequestProfileWidgetDwellersAndLandlordsHeaderActions'

import * as styles from './RequestProfileWidgetDwellersAndLandlords.module.css'

import ClosedEye from '../../../../icons/closed-eye.svg'
import OpenEye from '../../../../icons/open-eye.svg'

function RequestProfileWidgetDwellersAndLandlords({ isSkeleton, requestData }) {
  const { t } = useTranslation()

  const { config: ukConfig } = useUk()

  const { isVisibleToDwellers, sections, shouldRenderWidget } =
    getRequestProfileWidgetDwellersAndLandlordsData(requestData, ukConfig)

  return isSkeleton || shouldRenderWidget ? (
    <Widget
      contentContainerProps={{
        className: styles.dwellersContent,
      }}
      headerProps={{
        contentProps: {
          Actions: RequestProfileWidgetDwellersAndLandlordsHeaderActions,
          actionsProps: {
            isVisibleToDwellers,
          },
        },
      }}
      isSkeleton={isSkeleton}
      qaName={RequestProfileWidgetKey.INHABITANTS}
      title={t('RequestProfile.DwellersAndLandlordsWidgetTitleKey')}
    >
      <div className={styles.content}>
        {sections.map((section, index) => (
          <Fragment key={section.id}>
            {index > 0 ? <Divider className={styles.divider} /> : null}
            <WidgetContentItemsList
              Item={ProfileUserInfoItem}
              items={section.items}
              title={getRequestProfileWidgetDwellersAndLandlordsSectionTitle({
                count: section.items.length,
                sectionId: section.id,
                t,
              })}
              titleEndContent={
                <IconWithTooltip
                  Icon={section.isRequestVisible ? OpenEye : ClosedEye}
                  tooltip={t(
                    getRequestProfileWidgetDwellersAndLandlordsSectionVisibilityTooltipKey(
                      section
                    )
                  )}
                  tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
                />
              }
              titleWrapperClassName={styles.itemsListTitleWrapper}
            />
          </Fragment>
        ))}
      </div>
    </Widget>
  ) : null
}

export default RequestProfileWidgetDwellersAndLandlords
